import { HttpClient } from '@/shared/lib/http-client';

export const getVehicleInfoByNumber = async (number) => {
  const response = await HttpClient.get(`/directories/car/${number}`);

  return response.data?.data;
};
